import { logError } from '@/utils/logger'
import { db } from 'codemash'
import { CODEMASH_DB_KEYS } from '@/constants'

const initialState = () => ({
  list: []
})

export const state = initialState()

export const mutations = {
  RESET (state) {
    const newState = initialState()
    Object.keys(newState).forEach(key => {
      state[key] = newState[key]
    })
  },
  SET_LIST (state, list = []) {
    state.list = list
  }
}

export const getters = {
  list: state => state.list
}

export const actions = {
  async fetchFeedbackItems ({ commit, rootGetters }, { page = 0 } = {}) {
    try {
      const list = await db.getRecords(CODEMASH_DB_KEYS.FEEDBACK_ITEMS, page, 25)

      commit('SET_LIST', list)

      return list
    } catch (e) {
      logError(e, { page }, 'feedback items: error fetching items')

      return []
    }
  },
  saveItem ({ rootGetters }, item) {
    return db.saveRecord(CODEMASH_DB_KEYS.FEEDBACK_ITEMS, {
      ...item,
      username: rootGetters['auth/username'],
      status: 'new',
      votes: 0
    })
  }
}
